import { VariantAxisProduct } from 'modules/collections';
import { analyticsUtils } from 'utils/analytics-utils';
import { KITCHEN_PRICE_PDP_ELEMENT_BLOCK } from './kitchen-price-pdp-constants';

type GAProductInfo = {
  productName: string;
  productId: string;
  productPrice: number;
  productPrevPrice: null;
  productBelong: 'LeroyMerlin';
};

export const addToCartGAEvent = (productInfo: GAProductInfo, elementName: string, elementText: string) => {
  analyticsUtils.sendEvent('GA:clickButton', {
    elementBlock: KITCHEN_PRICE_PDP_ELEMENT_BLOCK,
    elementType: 'button',
    elementName,
    elementText,
    ...productInfo,
  });
};

export const navSlideClickGAEvent = (productInfo: GAProductInfo, elementText: string) => {
  analyticsUtils.sendEvent('GA:clickButton', {
    elementType: 'button',
    elementBlock: KITCHEN_PRICE_PDP_ELEMENT_BLOCK,
    elementName: 'mediaContent',
    elementText,
    ...productInfo,
  });
};

const FAST_DELIVERY_NAMES = ['nyuport-belaya-2-4-m', 'nyuport-topo-2-4-m'];

export const getDeliveryDays = (activePoint: VariantAxisProduct) => {
  const frameColor = activePoint.axesValues.find(({ id }) => id === '10002');

  if (FAST_DELIVERY_NAMES.includes(activePoint.name)) {
    return 10;
  }

  if (activePoint.name.includes('nyuport')) {
    return 21;
  }

  if (frameColor?.axis === 'Белый') {
    return 10;
  }

  return 21;
};

